import React, { memo, useEffect, useState } from "react";

import api, { useAsync } from "src/api";
import { useDebounce } from "src/utils";
import styles from "./style.css";

const AutoComplete = memo(props => {
  const { query, setQuery } = props;
  const [shown, setShown] = useState(false);

  const useAutocomp = useAsync(api.getSearchAutocomplete, { callOnMount: false });
  const _autocomp = useAutocomp({ query });
  const autocomp = useDebounce(query => _autocomp.call({ query }), 500);

  const [, data = []] = Array.isArray(_autocomp.data) ? _autocomp.data : [];

  useEffect(() => {
    setShown(true);
    autocomp(query);
  }, [query]);

  return shown ? (
    <div class={styles.container}>
      <ul>
        {data.map(d => (
          <li
            key={d}
            onClick={() => {
              setQuery(d);
              setTimeout(() => setShown(false), 200);
            }}
          >
            {d}
          </li>
        ))}
      </ul>
    </div>
  ) : null;
});

export default AutoComplete;
